"use client";
import { HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "./Overlay.module.css";

export interface OverlayProps extends HTMLProps<HTMLDivElement> {}

export default function Overlay({
	ref,
	children,
	className,
	...props
} : OverlayProps) {
	return (
		<div
			ref={ref}
			className={cn(
				styles.Overlay,
				className
			)}
			{...props}
		>
			{children}
		</div>
	);
}